// extracted by mini-css-extract-plugin
export default {"cardTitle":"ItemCard_cardTitle__lcBTZ","cardDescription":"ItemCard_cardDescription__dr676"};